
var id = "AverageSpending";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"AverageSpending\">\n<style type=\"text/css\">\n\t#AverageSpending .st0{fill:'';}\n</style>\n<path class=\"st0\" d=\"M63.2,2.1C28.6,2.1,0.6,30.1,0.6,64.7c0,34.6,28.1,62.7,62.7,62.7c34.6,0,62.7-28.1,62.7-62.7\n\tC125.9,30.1,97.8,2.1,63.2,2.1z M63.2,119.5C32.9,119.5,8.4,95,8.4,64.7c0-30.3,24.5-54.8,54.8-54.8c30.3,0,54.8,24.5,54.8,54.8\n\tC118.1,95,93.5,119.5,63.2,119.5z M87.2,29.5c-2,0.3-3.6,1.1-4.6,2.7L65.2,58.6L47.7,32.1c-1.3-1.5-2.8-2.4-4.6-2.7\n\tc-2.3,0.5-3.4,1.7-3.4,3.4c0,1.3,0.3,2.3,0.8,3.1c0.2,0.5,0.5,0.8,0.8,0.8l15.6,24.1h-9.1c-2.8,0.3-4.2,1.4-4.2,3.4\n\tc0,2,1.4,3.1,4.2,3.1H61v6.9H47.7c-2.8,0.3-4.2,1.4-4.2,3.4c0,2,1.4,3.1,4.2,3.1H61v15.3c0,2.6,1.4,3.8,4.2,3.8\n\tc2.5,0,3.9-1.3,4.2-3.8V80.8h13.3c2.5,0,3.9-1,4.2-3.1c-0.3-2-1.7-3.2-4.2-3.4H69.4v-6.9h13.3c2.5,0,3.9-1,4.2-3.1\n\tc-0.3-2-1.7-3.2-4.2-3.4h-9.1l15.6-24.1c0-0.3,0.1-0.5,0.4-0.8c0.8-1.3,1.1-2.3,1.1-3.1C90.4,31.1,89.3,30,87.2,29.5z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
